<div class="p-6">

  <!-- Título de bienvenida -->
  <div class="typography-title-s pt-2 pb-4" *ngIf="!isLoyalty2026Active">
    {{ 'welcome' | translate }} <span>{{ userInfo.firstName + ' ' + userInfo.lastName }}</span>
  </div>

  <div class="typography-title-s pt-2 pb-4" *ngIf="isLoyalty2026Active">
    {{ 'benefits_kb.loyalty_2026.hello_contact_name' | translate:{contactName: userInfo.firstName + ' ' + userInfo.lastName} }} <span class="pl-2 typography-body-m-light">{{ 'benefits_kb.loyalty_2026.what_do_you_need_today' | translate }}</span>
  </div>

  <!-- GRID de 2 columnas -->
  <div class="grid grid-cols-12 gap-6">
    <div class="col-span-12 space-y-6  md:col-span-12 lg:col-span-8 min-h-[280px]">

      <!-- Posición 1: arriba izq -->
        <!-- Architect: Hero; resto: YourActivity -->
        <!-- <app-hero-dekton *ngIf="is('Architect'); else yourActivity"></app-hero-dekton> -->
        <app-kblevel-2026 *ngIf="userInfo.accountType && ['RETAIL'].includes(userInfo.accountType) && isLoyalty2026Active"></app-kblevel-2026>

        <app-leads-block *ngIf="hasLeadsAcccess() && !isLoyalty2026Active"></app-leads-block>
        <app-leads-block-2026 *ngIf="hasLeadsAcccess() && isLoyalty2026Active"></app-leads-block-2026>


        <app-activity-block *ngIf="!hasLeadsAcccess() && userInfo.accountType !== 'RETAIL'"></app-activity-block>


      <!-- Posición 2: centro izq (todos CTAs) -->
      <!-- <div class="grid grid-cols-4 gap-4 bg-white h-[250px]"> -->
        <app-cta-block></app-cta-block>
      <!-- </div> -->

      <!-- Posición 3: abajo izq (Banners; Installer con limit=1) -->
      <div class="grid grid-cols-1 gap-4">
        <app-banners position="1"></app-banners>
      </div>

    </div>

    <!-- 📎 COLUMNA DERECHA -->
    <div class="col-span-12 space-y-6 md:col-span-12 lg:col-span-4">

      <!-- Posición 4: arriba derecha -->
      <!-- <div class="bg-black h-[200px] flex p-4 gap-4"> -->
        <!-- Fabricator/Installer: Ecosentino -->
        <div class="min-h-[280px]" style="gap:2px;">
          <div class="flex gap-4">
            <div class="flex-1 min-w-0" *ngIf="userInfo.accountType && ['FABRICATOR','INSTALLER'].includes(userInfo.accountType)">
              <app-ecosentino-banner></app-ecosentino-banner>
            </div>
            <div class="flex-1 min-w-0" *ngIf="userInfo.accountType && ['FABRICATOR','DISTRIBUTOR'].includes(userInfo.accountType) && ['US','CA','BR'].includes(userInfo.accountCountry || '')">
              <app-virtual-visit-banner ></app-virtual-visit-banner>
            </div>
          </div>
          <!-- KB: Fidelización -->
          <app-loyalty-block *ngIf="userInfo.accountType && ['RETAIL'].includes(userInfo.accountType) && userInfo.loyaltyLevel !== 'ADVANCED' && !isLoyalty2026Active"></app-loyalty-block>
          
          <!-- 2026 KB: WeCommerce (todos los niveles) -->
          <app-banner-wecommerce *ngIf="userInfo.accountType && ['RETAIL'].includes(userInfo.accountType) && isLoyalty2026Active && hasWeCommerceAccess()"></app-banner-wecommerce>
          
         

          <!-- Designer/Architect: Samples -->
          <app-samples-banner *ngIf="userInfo.accountType && ['DESIGNER','ARCHITECT'].includes(userInfo.accountType) && !isLoyalty2026Active"></app-samples-banner>
          <app-retail-advanced-banner *ngIf="userInfo.accountType && ['RETAIL'].includes(userInfo.accountType) && userInfo.loyaltyLevel == 'ADVANCED' && !isLoyalty2026Active"></app-retail-advanced-banner>

          <!-- Designer/Architect/Retail (sin WeCommerce): Samples 2026 -->
          <app-samples-banner *ngIf="userInfo.accountType && isLoyalty2026Active && ((['DESIGNER','ARCHITECT'].includes(userInfo.accountType)) || (userInfo.accountType === 'RETAIL' && !hasWeCommerceAccess()))"></app-samples-banner>

        </div>
      <!-- </div> -->

      <!-- Posición 5: abajo derecha (News para todos) -->
      <div class="bg-white p-0">
         <!-- <code>Whats new?</code> -->
        <app-news></app-news>
      </div>

    </div>
  </div>

  <app-confirm-modal
    [isOpen]="loyaltyNoSalesPopupOpen"
    confirmText="{{ 'home.loyalty_no_sales_popup_cta' | translate }}"
    cancelText=""
    (onConfirm)="goToRegisterSalesFromPopup()"
    (onCancel)="closeLoyaltyNoSalesPopup()"
    (onClose)="closeLoyaltyNoSalesPopup()"
    maxWidth="520"
  >
    <img src="assets/images/my-benefits/cosentino-rewards.png" alt="Cosentino Rewards" class="w-full max-h-[180px] object-cover mb-2" />
    <span class="typography-title-m text-primary text-center">{{ 'home.loyalty_no_sales_popup_title' | translate }}</span>
    <p class="typography-body-l-regular text-center text-text-secondary">{{ 'home.loyalty_no_sales_popup_body' | translate }}</p>
  </app-confirm-modal>
</div>
